import type React from "react";
import ReactHowler from "react-howler";

import {useCurrentUserSettings} from "~/api/hooks/useSettings";
import {useUserInteraction} from "~/contexts/userInteraction/UserInteractionContext";
import {cld} from "~/firebase/cloudinary";

const BackgroundMusic: React.FC = () => {
  const {data: settings} = useCurrentUserSettings();
  const {hasUserInteracted} = useUserInteraction();

  return (
    <ReactHowler
      src={cld.video("ambient-fantasy-314682_itp3wc").quality("auto").toURL()}
      format={["mp3"]}
      playing={hasUserInteracted && (settings?.musicVolume ?? 0) > 0}
      loop={true}
      volume={settings?.musicVolume ?? 0}
      preload={true}
    />
  );
};

export default BackgroundMusic;
